import React, { ReactNode } from "react";
import { Dialog } from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import "../../styles/dialog-premium.css";

interface SchedulePostDialogProps {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
  footer: ReactNode;
}

const SchedulePostDialog: React.FC<SchedulePostDialogProps> = ({
  open,
  onClose,
  children,
  footer,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    fullWidth
    maxWidth="sm"
    className="premium-dialog-root"
    BackdropProps={{ className: "premium-modal-backdrop" }}
    PaperProps={{
      elevation: 0,
      className: "premium-dialog-paper premium-dialog-paper--wide",
    }}
  >
    <div className="premium-dialog-header">
      <h2 className="premium-dialog-title">Confirm and Schedule Post</h2>
      <button
        type="button"
        className="premium-dialog-close"
        onClick={onClose}
        aria-label="Close"
      >
        <CloseRoundedIcon sx={{ fontSize: 18 }} />
      </button>
    </div>
    <div className="premium-dialog-body">{children}</div>
    <div className="premium-dialog-footer">{footer}</div>
  </Dialog>
);

export default SchedulePostDialog;
